import { ServerApi } from 'modules/api/server-api';

export const fetchMe = (api: ServerApi) => async () => {
  const response = await api.get('/user/me');
  return response.data;
};
